const MENTOR_LOGIN = "mentor-login";
const MENTEE_LOGIN = "mentee-login";
const SUPER_ADMIN_LOGIN = "super-admin-login";
const COMPANY_ADMIN_LOGIN = "company-admin-login";
const LOGOUT = "logout";
const TOGGLE_LOGIN_MODAL = "toggle-login-modal";
const TOGGLE_SIGNUP_MODAL = "toggle-signup-modal";
const SAVE_CHANGES = "save";
const CANCEL_EDIT = "cancel";
const NAVIGATE_COMPANY_PAGE = "navigate-company-page";

export {
  MENTOR_LOGIN,
  MENTEE_LOGIN,
  SUPER_ADMIN_LOGIN,
  COMPANY_ADMIN_LOGIN,
  LOGOUT,
  TOGGLE_LOGIN_MODAL,
  TOGGLE_SIGNUP_MODAL,
  SAVE_CHANGES,
  CANCEL_EDIT,
  NAVIGATE_COMPANY_PAGE,
};
